import React from 'react';
import propTypes from 'prop-types';
import { TriangleAlert } from 'lucide-react';

/**
 * warning pill used to flag an agent/record in dashboard tables
 * @param text - flag copy shown inside the pill
 */
export default function FlagPill({ text }) {
  return (
    <span className='inline-flex max-w-full items-center gap-1 truncate rounded-full border px-2 py-0.5 text-xs font-medium text-pending bg-pending/10 border-pending'>
      <TriangleAlert className='size-3.5 shrink-0' aria-hidden />
      <span className='pt-0.5 truncate'>{text}</span>
    </span>
  );
}

FlagPill.propTypes = {
  text: propTypes.string.isRequired
};
